import { Tick } from '../../../../Icons/tick';

interface IPOINTERS {
  item: string;
}
export const Pointers = ({ item }: IPOINTERS): JSX.Element => {
  return (
    <div className="flex items-center gap-4 w-1/3 sm:w-full">
      <div className="flex items-start gap-2">
        <div className="2/12">
          <Tick className="mt-2 sm:w-3" />
        </div>
        <div className="text-base text-font-200 font-medium"> {item}</div>
      </div>
    </div>
  );
};
